<template>
    <div class="avatar" :class="size">
        <img v-if="src" :src="src" :width="width" v-b-tooltip :title="title" class="avatar-img" :class="typeClass"  alt=""/>
        <div v-else v-b-tooltip :title="title" class="user-avatar text-center border border-1" :style="[nameAttr ? { 'background-color': color } : '' ]" :class="typeClass">
            <span :class="textSize || hsize" class="text-white" v-if="nameAttr && color">{{ nameAttr }}</span>
            <span :class="hsize" class="text-muted fe fe-image" v-else></span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: ['src', 'width', 'type', 'size', 'title', 'color', 'userName', 'textSize'],
    computed: {
        hsize() {
            if (this.size == 'avatar-xs') return 'h4';
            return 'h1';
        },
        typeClass() {
            let maps = {
                'rounded': 'rounded',
                'circle': 'rounded-circle',
            }
            return maps[this.type] || '';
        },
        nameAttr() {
            if (!this.userName) return;

            if ( this.userName.first_name || this.userName.last_name )
                return this.userName.last_name.charAt(0) + this.userName.first_name.charAt(0);
            if ( this.userName.firstName || this.userName.lastName )
                return this.userName.lastName.charAt(0) + this.userName.firstName.charAt(0);
        }

    }
}

</script>

<style scoped lang="scss">
    .user-avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        position: relative;
        span {
            padding: 0;
            margin: 0;
        }
    }

</style>
